import { render, staticRenderFns } from "./periodManagement.vue?vue&type=template&id=4dbd43c9"
import script from "./periodManagement.vue?vue&type=script&lang=js"
export * from "./periodManagement.vue?vue&type=script&lang=js"
import style0 from "./periodManagement.vue?vue&type=style&index=0&id=4dbd43c9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports